/**
 * Gesture profile map — maps RecurringGesture to visual effects.
 * Consumed by BuddyCharacter renderer, not by state engines.
 */

import { RecurringGesture } from '@/lib/state/baselineMoodComposer';

export interface GestureEffect {
  eyeEffect?: 'blink' | 'lookUp' | 'squint';
  bodyEffect?: { y?: number[]; x?: number[]; scale?: number[]; rotate?: number[] };
  duration: number;
}

export const GESTURE_EFFECTS: Record<RecurringGesture, GestureEffect> = {
  longBlink:        { eyeEffect: 'blink', duration: 600 },
  softSway:         { bodyEffect: { x: [0, 3, -3, 0] }, duration: 2000 },
  satisfiedBounce:  { bodyEffect: { y: [0, -4, 0], scale: [1, 1.02, 1] }, duration: 800 },
  doubleBlink:      { eyeEffect: 'blink', duration: 400 },
  worriedGlance:    { bodyEffect: { x: [0, -3, 0] }, eyeEffect: 'lookUp', duration: 1200 },
  sigh:             { bodyEffect: { y: [0, 2, 0], scale: [1, 0.98, 1] }, duration: 1500 },
  tensionPulse:     { bodyEffect: { scale: [1, 1.03, 1] }, duration: 600 },
  confidentLift:    { bodyEffect: { y: [0, -5, -3] }, duration: 1000 },
  glowPulse:        { bodyEffect: { scale: [1, 1.04, 1] }, duration: 900 },
  smirkHold:        { duration: 1200 },
  droop:            { bodyEffect: { y: [0, 3, 2] }, duration: 1800 },
  cautiousBlink:    { eyeEffect: 'blink', duration: 500 },
  downwardDrift:    { bodyEffect: { y: [0, 2, 1] }, duration: 2000 },
  deadpanStare:     { duration: 2500 },
  boredBlink:       { eyeEffect: 'blink', duration: 700 },
  slowSideSway:     { bodyEffect: { x: [0, 4, -4, 0] }, duration: 3000 },
  upwardGlance:     { eyeEffect: 'lookUp', duration: 1500 },
  nervousWobble:    { bodyEffect: { x: [0, -2, 2, -1, 0] }, duration: 800 },
  anticipatoryLean: { bodyEffect: { y: [0, -3, -2] }, duration: 1200 },
  delayedExhale:    { bodyEffect: { y: [0, 1, -1, 0], scale: [1, 0.99, 1.01, 1] }, duration: 2000 },
};
